<template>
    <div>
        <choice-wrap>
            <template v-slot:title>
                <img src="../../assets/images/setup/home.svg" alt="" class="mr-3">
                <h3> Your Home Details</h3>
            </template>

            <div class="row">
                <div class="col-12 col-lg-6">
                    <h5>Address:</h5>
                    <p class="m-0 text-silver" v-if="address.address !== ''">{{ address.address }}</p>
                    <p class="m-0 text-silver">
                        {{ address.postcode.toUpperCase() }}
                    </p>
                    <div class="mt-3">
                        <a href="#" @click.prevent="$refs.modal.show()">Change address</a>
                    </div>
                </div>
                <div class="col-12 col-lg-5">
                    <h5>Property type:</h5>
                    <p class="m-0 text-silver"  v-if="!showSelectPropertyType">
                        {{selectedPropertyType.title}}
                    </p>
                    <div class="form-group" v-if="showSelectPropertyType || !this.selected.currentPropertyType">
                            <choice v-model="selected.currentPropertyType" :data="data.currentPropertyType"
                                    :errors.sync="errors.currentPropertyType" :show-buttons="false" show-select-control
                            select-placeholder="Please select"></choice>

                    </div>
                    <div class="mt-3">
                        <a href="#" @click.prevent="showSelectPropertyType = true" v-if="!showSelectPropertyType">Change type</a>
                    </div>
                </div>
            </div>
        </choice-wrap>
        <choice-wrap>
            <template v-slot:title>
                <img src="../../assets/images/setup/bed.svg" alt="" class="mr-3">
                <h3>How large is your property</h3>
            </template>
            <choice v-model="selected.currentPropertySize" :data="data.currentPropertySize" :errors.sync="errors.currentPropertySize" :show-button-title="true" />
        </choice-wrap>
        <choice-wrap>
            <template v-slot:title>
                <img src="../../assets/images/setup/property.svg" alt="" class="mr-3">
                <h3>Do you rent or own your home?</h3>
            </template>
            <choice v-model="selected.currentPropertyOwnership" :data="data.currentPropertyOwnership" :errors.sync="errors.currentPropertyOwnership" :show-button-title="true" />
        </choice-wrap>

        <address-modal ref="modal"  @selected="onAddressSelected" />
    </div>
</template>

<script>
import Choice from "../../components/setup/Choice";
import ChoiceWrap from "../../components/setup/ChoiceWrap";
import SetupValidationHelper from "../../mixins/SetupValidationHelper";
import SetupChoiceUpdate from "../../mixins/SetupChoiceUpdate";
import AddressModal from "../../components/setup/AddressModal";
import {capitalize} from "lodash"
import store from "@/store";
import api from "@/utils/api";
import ClearStoreMixin from "@/mixins/ClearStoreMixin";

export default {
        name: "Home",
        components: {AddressModal, ChoiceWrap, Choice},
        mixins: [SetupValidationHelper, SetupChoiceUpdate, ClearStoreMixin],
        data: function () {
            return {
                nextRouteName: 'SetupCurrent',
                selected: {
                    currentPropertySize: null,
                    currentPropertyOwnership: null,
                    currentPropertyType: null,
                },
                errors: {
                    currentPropertySize: [],
                    currentPropertyOwnership: [],
                    currentPropertyType: [],
                },
                showSelectPropertyType: false,
            }
        },
        methods: {
            validate: function () {
                this.resetErrors();

                if(!this.$store.getters['setup/hasAddress']){
                    return;
                }
                if(!this.selected.currentPropertySize){
                    this.errors.currentPropertySize.push("Please select your property size!")
                }
                if(!this.selected.currentPropertyOwnership){
                    this.errors.currentPropertyOwnership.push("Please select if you rent or own your home!")
                }
                if(!this.selected.currentPropertyType){
                    this.errors.currentPropertyType.push("Please select your property type!")
                }
            },
            onAddressSelected: function (address) {
                this.clearStore()
                this.$store.commit('setup/setAddress', address);
            }
        },
        watch: {
            'selected.currentPropertyType': function () {
                this.showSelectPropertyType = false;
            },
        },
        filters: {
            capitalize: capitalize
        },
        computed: {
            data: function(){
              return this.$store.getters['setup/stepOneData']
            },
            address: function () {
                return this.$store.getters['setup/currentAddress'] || {address: [], postcode: ''}
            },
            selectedPropertyType: function () {
                let filtered = this.data.currentPropertyType.filter((value => value.id === this.selected.currentPropertyType));
                return filtered.pop() || { title: ''};
            }
        },
        mounted() {
            if(!this.selected.currentPropertyType){
                this.showSelectPropertyType = true;
            }
        },
        beforeRouteEnter: function (to, from, next){
            api.survey().then(response => {
                store.commit('setup/setData', response.data.data)
                next()
            }).catch(() => {
                this.$toast.error("A problem occurred! Please try again later!")
                next({name: 'Home'})
            })
        }
    }
</script>

<style scoped>

</style>
